
import Basemap from "@arcgis/core/Basemap.js";
import LocalBasemapsSource from "@arcgis/core/widgets/BasemapGallery/support/LocalBasemapsSource.js";



// Pure Utility: No React, No State, 100% Testable
export const buildBasemapSource = (configs) => {
  const customBasemaps = (configs || []).map(bm => {
    if (bm.type === "portal") return new Basemap({ portalItem: { id: bm.id } });
    return Basemap.fromId(bm.id);
  });
  return new LocalBasemapsSource({ basemaps: customBasemaps });
};

export const findLayerOrSublayer = (map, title) => {
  let found = null;
  map.layers.forEach(layer => {
    if (found) return;
    
    // Check top-level (FeatureLayer, GeoJSON, etc)
    if (layer.title === title) {
      found = layer;
    } 
    // Check inside MapImageLayer sublayers
    else if (layer.type === "map-image") {
      const sublayer = layer.sublayers.find(s => s.title === title);
      if (sublayer) found = sublayer;
    }
  });
  return found;
};